export const getLocalContent = (cityName: string, regionSlug: string, lang: 'en' | 'es' | 'ru' | 'zh' = 'en') => {
  const getRegionSpecifics = () => {
    switch (regionSlug) {
      case "sacramento-area":
        return {
          landmarks: ["the State Capitol", "Old Sacramento", "the American River Parkway"],
          landmarksEs: ["el Capitolio del Estado", "el Viejo Sacramento", "el American River Parkway"],
          landmarksRu: ["Капитолий штата", "Старый Сакраменто", "Американ Ривер Паркуэй"],
          landmarksZh: ["州议会大厦", "老萨克拉门托", "美国河公园大道"],
          issues: ["dust from the valley", "pollen in the spring", "hard water stains"],
          issuesEs: ["el polvo del valle", "el polen en primavera", "las manchas de agua dura"],
          issuesRu: ["пылью из долины", "весенней пыльцой", "пятнами от жесткой воды"],
          issuesZh: ["山谷灰尘", "春季花粉", "硬水渍"],
          neighborhoods: ["Midtown", "East Sac", "Natomas"]
        };
      case "los-angeles":
        return {
          landmarks: ["the Hollywood Sign", "Griffith Observatory", "Santa Monica Pier"],
          landmarksEs: ["el Letrero de Hollywood", "el Observatorio Griffith", "el Muelle de Santa Mónica"],
          landmarksRu: ["знаком Голливуда", "Обсерваторией Гриффита", "пирсом Санта-Моники"],
          landmarksZh: ["好莱坞标志", "格里菲斯天文台", "圣莫尼卡码头"],
          issues: ["smog and city dust", "beach sand", "traffic pollution"],
          issuesEs: ["el smog y el polvo de la ciudad", "la arena de la playa", "la contaminación del tráfico"],
          issuesRu: ["смогом и городской пылью", "пляжным песком", "загрязнением от транспорта"],
          issuesZh: ["雾霾和城市灰尘", "海滩沙子", "交通污染"],
          neighborhoods: ["Downtown LA", "Westside", "The Valley"]
        };
      case "phoenix-area":
        return {
          landmarks: ["Camelback Mountain", "Desert Botanical Garden", "South Mountain"],
          landmarksEs: ["la Montaña Camelback", "el Jardín Botánico del Desierto", "South Mountain"],
          landmarksRu: ["горой Кэмелбэк", "Пустынным ботаническим садом", "Южной горой"],
          landmarksZh: ["驼背山", "沙漠植物园", "南山"],
          issues: ["desert dust", "monsoon season debris", "hard water build-up"],
          issuesEs: ["el polvo del desierto", "los escombros de la temporada de monzones", "la acumulación de agua dura"],
          issuesRu: ["пылью пустыни", "мусором сезона муссонов", "налетом от жесткой воды"],
          issuesZh: ["沙漠灰尘", "季风季节杂物", "硬水垢"],
          neighborhoods: ["Downtown", "Arcadia", "Biltmore"]
        };
      case "san-francisco":
        return {
          landmarks: ["the Golden Gate Bridge", "Alcatraz", "Fisherman's Wharf"],
          landmarksEs: ["el Puente Golden Gate", "Alcatraz", "Fisherman's Wharf"],
          landmarksRu: ["мостом Золотые Ворота", "Алькатрасом", "Рыбацкой пристанью"],
          landmarksZh: ["金门大桥", "恶魔岛", "渔人码头"],
          issues: ["fog moisture and mold", "city soot", "salt air"],
          issuesEs: ["la humedad de la niebla y el moho", "el hollín de la ciudad", "el aire salado"],
          issuesRu: ["влагой от тумана и плесенью", "городской сажей", "соленым воздухом"],
          issuesZh: ["雾气湿润和霉菌", "城市烟灰", "咸空气"],
          neighborhoods: ["SOMA", "The Mission", "Marina District"]
        };
      case "san-diego":
        return {
          landmarks: ["Balboa Park", "Gaslamp Quarter", "Coronado Island"],
          landmarksEs: ["el Parque Balboa", "el Barrio Gaslamp", "la Isla Coronado"],
          landmarksRu: ["парком Бальбоа", "кварталом Гасламп", "островом Коронадо"],
          landmarksZh: ["巴尔博亚公园", "瓦斯灯街区", "科罗纳多岛"],
          issues: ["coastal salt air", "beach sand", "sun damage"],
          issuesEs: ["el aire salado de la costa", "la arena de la playa", "el daño solar"],
          issuesRu: ["прибрежным соленым воздухом", "пляжным песком", "выгоранием на солнце"],
          issuesZh: ["沿海咸空气", "海滩沙子", "阳光伤害"],
          neighborhoods: ["North Park", "La Jolla", "Pacific Beach"]
        };
      case "orange-county":
        return {
          landmarks: ["Disneyland", "Huntington Beach Pier", "Crystal Cove"],
          landmarksEs: ["Disneyland", "el Muelle de Huntington Beach", "Crystal Cove"],
          landmarksRu: ["Диснейлендом", "пирсом Хантингтон-Бич", "Кристал Коув"],
          landmarksZh: ["迪士尼乐园", "亨廷顿海滩码头", "水晶湾"],
          issues: ["beach sand", "coastal moisture", "hard water"],
          issuesEs: ["la arena de la playa", "la humedad costera", "el agua dura"],
          issuesRu: ["пляжным песком", "прибрежной влажностью", "жесткой водой"],
          issuesZh: ["海滩沙子", "沿海湿气", "硬水"],
          neighborhoods: ["Newport Coast", "Irvine", "Anaheim Hills"]
        };
      case "santa-clara":
        return {
          landmarks: ["Silicon Valley tech campuses", "Levi's Stadium", "Santana Row"],
          landmarksEs: ["los campus tecnológicos de Silicon Valley", "el Estadio Levi's", "Santana Row"],
          landmarksRu: ["технологическими кампусами Кремниевой долины", "стадионом Левис", "Сантана Роу"],
          landmarksZh: ["硅谷科技园区", "李维斯体育场", "桑塔纳街"],
          issues: ["city dust", "pollen", "hard water"],
          issuesEs: ["el polvo de la ciudad", "el polen", "el agua dura"],
          issuesRu: ["городской пылью", "пыльцой", "жесткой водой"],
          issuesZh: ["城市灰尘", "花粉", "硬水"],
          neighborhoods: ["Willow Glen", "Almaden", "Cupertino"]
        };
      default:
        return {
          landmarks: ["local parks", "downtown shops", "neighborhood schools"],
          landmarksEs: ["los parques locales", "las tiendas del centro", "las escuelas del vecindario"],
          landmarksRu: ["местными парками", "магазинами в центре", "школами района"],
          landmarksZh: ["当地公园", "市中心商店", "社区学校"],
          issues: ["seasonal dust", "pollen", "everyday grime"],
          issuesEs: ["el polvo estacional", "el polen", "la suciedad diaria"],
          issuesRu: ["сезонной пылью", "пыльцой", "повседневной грязью"],
          issuesZh: ["季节性灰尘", "花粉", "日常污垢"],
          neighborhoods: ["downtown", "local suburbs", "residential areas"]
        };
    }
  };

  const specifics = getRegionSpecifics();

  if (lang === 'es') {
    return {
      heroSubtitle: `Ya sea que pase sus fines de semana explorando ${specifics.landmarksEs[0]} o relajándose en ${specifics.neighborhoods[0]}, regrese a una casa impecable en ${cityName}.`,
      localIssuesText: `Las casas en ${cityName} a menudo lidian con ${specifics.issuesEs[0]} y ${specifics.issuesEs[1]}. Nuestros limpiadores expertos utilizan técnicas especializadas para afrontar estos desafíos locales.`,
      uniqueFaqs: [
        {
          question: `¿Cómo manejan ${specifics.issuesEs[0]} en las casas de ${cityName}?`,
          answer: `Utilizamos soluciones de limpieza especializadas y ecológicas diseñadas específicamente para combatir ${specifics.issuesEs[0]} y ${specifics.issuesEs[1]} comunes en ${cityName}. Nuestra tecnología de microfibra atrapa las partículas en lugar de esparcirlas.`
        },
        {
          question: `¿Prestan servicio en todos los vecindarios de ${cityName}, incluyendo cerca de ${specifics.landmarksEs[1]}?`,
          answer: `¡Sí! Brindamos servicios integrales de limpieza en todo ${cityName}, desde casas cerca de ${specifics.landmarksEs[1]} hasta ${specifics.neighborhoods[1]} y más allá.`
        }
      ]
    };
  }

  if (lang === 'ru') {
    return {
      heroSubtitle: `Проводите ли вы выходные, исследуя ${specifics.landmarksRu[0]}, или отдыхаете в районе ${specifics.neighborhoods[0]}, возвращайтесь в безупречно чистый дом в ${cityName}.`,
      localIssuesText: `Дома в ${cityName} часто сталкиваются с ${specifics.issuesRu[0]} и ${specifics.issuesRu[1]}. Наши профессиональные уборщики используют специальные методы для решения этих местных проблем.`,
      uniqueFaqs: [
        {
          question: `Как вы справляетесь с ${specifics.issuesRu[0]} в домах города ${cityName}?`,
          answer: `Мы используем специальные экологически чистые чистящие средства, разработанные специально для борьбы с ${specifics.issuesRu[0]} и ${specifics.issuesRu[1]}, которые часто встречаются в ${cityName}. Наша технология микрофибры улавливает частицы, а не разносит их.`
        },
        {
          question: `Обслуживаете ли вы все районы ${cityName}, включая территорию рядом с ${specifics.landmarksRu[1]}?`,
          answer: `Да! Мы предоставляем комплексные услуги по уборке по всему городу ${cityName}, от домов рядом с ${specifics.landmarksRu[1]} до района ${specifics.neighborhoods[1]} и за его пределами.`
        }
      ]
    };
  }

  if (lang === 'zh') {
    return {
      heroSubtitle: `无论您是在周末探索${specifics.landmarksZh[0]}，还是在${specifics.neighborhoods[0]}放松身心，让您在${cityName}的家保持一尘不染。`,
      localIssuesText: `${cityName}的房屋经常面临${specifics.issuesZh[0]}和${specifics.issuesZh[1]}的问题。我们的专业清洁人员使用专门的技术来应对这些当地挑战。`,
      uniqueFaqs: [
        {
          question: `你们如何处理${cityName}房屋中的${specifics.issuesZh[0]}？`,
          answer: `我们使用专门的环保清洁解决方案，专门用于对抗${cityName}常见的${specifics.issuesZh[0]}和${specifics.issuesZh[1]}。我们的微纤维技术可捕获颗粒，而不是将其扩散。`
        },
        {
          question: `你们的服务覆盖${cityName}的所有社区吗，包括${specifics.landmarksZh[1]}附近？`,
          answer: `是的！我们在整个${cityName}提供全面的清洁服务，从${specifics.landmarksZh[1]}附近的房屋到${specifics.neighborhoods[1]}及更远的地方。`
        }
      ]
    };
  }

  return {
    heroSubtitle: `Whether you spend your weekends exploring ${specifics.landmarks[0]} or relaxing in ${specifics.neighborhoods[0]}, come home to a spotless house in ${cityName}.`,
    localIssuesText: `Homes in ${cityName} often deal with ${specifics.issues[0]} and ${specifics.issues[1]}. Our expert cleaners use specialized techniques to tackle these local challenges.`,
    uniqueFaqs: [
      {
        question: `How do you handle ${specifics.issues[0]} in ${cityName} homes?`,
        answer: `We use specialized, eco-friendly cleaning solutions specifically designed to combat ${specifics.issues[0]} and ${specifics.issues[1]} common in ${cityName}. Our microfiber technology traps particles rather than spreading them.`
      },
      {
        question: `Do you service all neighborhoods in ${cityName}, including near ${specifics.landmarks[1]}?`,
        answer: `Yes! We provide comprehensive cleaning services throughout all of ${cityName}, from homes near ${specifics.landmarks[1]} to ${specifics.neighborhoods[1]} and beyond.`
      }
    ]
  };
};